import React from 'react';
import { motion, type HTMLMotionProps } from 'framer-motion';

export type GlassCardVariant = 'default' | 'deep' | 'gold' | 'cyan' | 'purple' | 'magenta' | 'interactive';

export interface GlassCardProps extends HTMLMotionProps<'div'> {
  variant?: GlassCardVariant;
  glow?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const GlassCard: React.FC<GlassCardProps> = ({
  variant = 'default',
  glow = false,
  children,
  className = '',
  ...motionProps
}) => {
  const variantClassMap: Record<GlassCardVariant, string> = {
    default: 'glass-panel',
    deep: 'glass-panel-deep',
    gold: 'glass-panel-gold',
    cyan: 'glass-panel-glow',
    purple: 'glass-panel-purple',
    magenta: 'glass-panel-magenta',
    interactive: 'glass-panel hover:border-cyan-500/40 hover:shadow-cyan-500/20 cursor-pointer transition-all',
  };

  const glowClass = glow ? 'shadow-[0_0_30px_-5px_rgba(168,85,247,0.25)]' : '';

  return (
    <motion.div
      className={`rounded-3xl p-5 sm:p-6 relative overflow-hidden ${variantClassMap[variant]} ${glowClass} ${className}`}
      {...motionProps}
    >
      {children}
    </motion.div>
  );
};
